import React, { Component, PropTypes } from 'react';
import { Panel, Row, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/users';
import { Input } from '../components/inputs';
import { onInputChange } from '../utils/helpers';

const mapStateToProps = state => ({
  token: state.auth.token,
  userId: state.auth.userId,
  userData: state.users.userData,
  isPushingData: state.users.isPushingData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

class FederationWrapper extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    isPushingData: PropTypes.bool.isRequired,
    userData: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      contactData: undefined,
    };

    this.onInputChange = onInputChange().bind(this);
  }

  componentWillMount() {
    this.fetchData();
  }

  componentWillReceiveProps(nextProps) {
    const { userData } = nextProps;

    if (userData) {
      this.setState({
        contactData: {
          name: userData.name,
          email: userData.email,
        },
      });
    }
  }

  fetchData() {
    const { token, actions, userId } = this.props;

    actions.fetchUser(token, userId);
  }

  handleSubmitForm = e => {
    e.preventDefault();

    const { contactData } = this.state;
    const { token, actions, userId } = this.props;

    actions.updateUserContactInfo(token, userId, contactData);
  };

  render() {
    const { children, isPushingData } = this.props;
    const { contactData } = this.state;

    return (
      <div>
        <Panel header="Event Information" bsStyle="primary">
          {window.cviConfig.nominativeDate ?
          <p>
            <strong>Nominative entries deadline:</strong> {window.cviConfig.nominativeDate}
          </p>
          : null}
          <p>
            <strong>Definitive entries deadline:</strong> {window.cviConfig.deadlineDate}
          </p>
          <p>
            If you need any help or you have some additional request please contact{' '}
            <a href={`mailto:${window.cviConfig.supportEmail}`}>{window.cviConfig.supportEmail}</a>
          </p>
        </Panel>

        <Panel header="Contact Information" bsStyle="primary">
          <Row>
            <Col xs={6} sm={5}>
              <Input
                type="text"
                onChange={this.onInputChange('contactData.name')}
                value={contactData && contactData.name}
                name="name"
                label="Responsible person for the entry"
              />
            </Col>

            <Col xs={6} sm={5}>
              <Input
                type="text"
                onChange={this.onInputChange('contactData.email')}
                value={contactData && contactData.email}
                name="email"
                label="E-Mail"
              />
            </Col>

            <Col xs={12} sm={2}>
              <Button
                type="submit"
                onClick={this.handleSubmitForm}
                disabled={isPushingData}
                bsStyle="primary"
                block
                style={{ marginTop: 25 }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Panel>

        {children}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FederationWrapper)


// WEBPACK FOOTER //
// ./src/containers/FederationWrapper.js